[
  {
    "key": "umich-rent",
    "campus": "umich",
    "product": "rent",
    "appId": "xs7c2ba511w18yshkchx676dts83k258",
    "instanceId": "y17by0mnnwy4rrssb3rkkvjjvs83k416",
    "name": "Rate My Rent UMICH",
    "handle": "rate-my-rent-umich",
    "version": 8,
    "sourceFile": "products/umich-rent.tsx",
    "gitRepoName": "mini-app-rate-my-rent-umich-83k258",
    "gitCommit": "0810f0d70e491fc6f15abe036100902e235cd3e8",
    "sourceSha256": "27525d251df36dd44720a121855cc97fde3f73e293d21e374cb1f073ea85fafb",
    "sessionPolicy": {
      "allowLoggedOutLiveView": true,
      "allowLoggedOutLiveWrite": false,
      "allowPrivateSessions": false,
      "enforceSingleSession": true,
      "sharedCommunityId": "vh71k4wakf4cb5wntgb22ak44h7yqawf",
      "sharedSessionScope": "community"
    },
    "leadCapture": {
      "copy": {
        "badge": "Built by a Social Builder on A1Zap",
        "continueCta": "Continue on web",
        "primaryCta": "Start Sign Up",
        "signInCta": "I already have an account",
        "subtitle": "Save your data. Campus-locked to UMich",
        "title": "Sign up to log your rent"
      },
      "domainRule": {
        "allowedDomains": [
          "umich.edu"
        ],
        "message": "Use your UMich email to continue",
        "mode": "allowlist"
      },
      "enabled": true,
      "requiredFields": [
        {
          "key": "email",
          "label": "School email",
          "placeholder": "you@umich.edu",
          "required": true,
          "type": "email"
        }
      ],
      "trigger": "on_load"
    },
    "exportedAt": "2026-09-08T17:17:21.334Z"
  },
  {
    "key": "ut-rent",
    "campus": "ut-austin",
    "product": "rent",
    "appId": "xs725h596q3ksbjw5kehbjbaa97z3w38",
    "instanceId": "y178kewb9vg74hy3m36pmy2gdh7z20nc",
    "name": "Rate My Rent",
    "handle": "rate-my-rent-8hrx",
    "version": 240,
    "sourceFile": "products/ut-rent.tsx",
    "gitRepoName": "mini-app-rate-my-rent-8hrx-7z3w38",
    "gitCommit": "7ab35652daf1b44de1e5076d8da3f7fac1817bf2",
    "sourceSha256": "da527c509ef59d72637531c64d8f4cd0da81df1737fee42211a958b1b939d623",
    "sessionPolicy": {
      "allowLoggedOutLiveView": true,
      "allowLoggedOutLiveWrite": false,
      "allowPrivateSessions": false,
      "enforceSingleSession": true,
      "sharedSessionScope": "global"
    },
    "leadCapture": {
      "copy": {
        "badge": "Built by a Social Builder on A1Zap",
        "continueCta": "Continue on web",
        "primaryCta": "Start Sign Up",
        "signInCta": "I already have an account",
        "subtitle": "Save your data. Campus-locked to UT Austin",
        "title": "Sign up to log your rent"
      },
      "domainRule": {
        "allowedDomains": [
          "utexas.edu"
        ],
        "message": "Use your UT Austin email to continue",
        "mode": "allowlist"
      },
      "enabled": true,
      "requiredFields": [
        {
          "key": "email",
          "label": "School email",
          "placeholder": "you@utexas.edu",
          "required": true,
          "type": "email"
        }
      ],
      "trigger": "on_load"
    },
    "exportedAt": "2026-09-08T17:17:21.339Z"
  },
  {
    "key": "ut-leases",
    "campus": "ut-austin",
    "product": "leases",
    "appId": "xs70bmw1z9rzfec3jkvq33rp5983z3cw",
    "instanceId": "y1716bhfw4b3bh163v9r4ntesd8bfbn0",
    "name": "Find my Lease UT",
    "handle": "findmylease-ut",
    "version": 325,
    "sourceFile": "products/ut-leases.tsx",
    "gitRepoName": "mini-app-rentright-rac3-83z3cw",
    "gitCommit": "f8456a49a24fbcbf07b9ea62823b4b8f6146f314",
    "sourceSha256": "17ab280cb626c1514dce76bba735470817f6580e9f0e01d6187efab86082c272",
    "sessionPolicy": {
      "allowLoggedOutLiveView": true,
      "allowLoggedOutLiveWrite": false,
      "allowPrivateSessions": false,
      "enforceSingleSession": true,
      "sharedCommunityId": "vh7e966x9phjahy5rw7mjf1b4x7s6cwg",
      "sharedSessionScope": "community"
    },
    "leadCapture": {
      "copy": {
        "primaryCta": "Start Sign Up",
        "signInCta": "I already have an account",
        "subtitle": "Use your UT email to unlock real rents, honest student reviews, and your saved shortlist.",
        "title": "Sign up to see what UT students actually pay"
      },
      "delayMs": 800,
      "domainRule": {
        "allowedDomains": [
          "utexas.edu"
        ],
        "message": "Use your UT Austin email to continue",
        "mode": "allowlist"
      },
      "enabled": true,
      "requiredFields": [
        {
          "key": "email",
          "label": "School email",
          "maxLength": 120,
          "placeholder": "you@utexas.edu",
          "required": true,
          "type": "email"
        }
      ],
      "submitBehavior": {
        "onSuccess": "start_signup"
      },
      "trigger": "on_load"
    },
    "exportedAt": "2026-09-08T17:17:21.341Z"
  },
  {
    "key": "tamu-rent",
    "campus": "texas-am",
    "product": "rent",
    "appId": "xs7f26y95agdn9jmmx2t9nmb9n83wyrf",
    "instanceId": "y178xd29vcdbqqkj2dtf8ymeg184psr7",
    "name": "Aggie Rent Rater",
    "handle": "aggie-rent-rater-p481",
    "version": 11,
    "sourceFile": "products/tamu-rent.tsx",
    "gitRepoName": "mini-app-aggie-rent-rater-p481-83wyrf",
    "gitCommit": "19c7d7bfe83008cebe054c5bb875dc7ee064e7c7",
    "sourceSha256": "5c5965743ab564f13a6f7245ad56c9faf3e2533512881a043a11896701bcc438",
    "sessionPolicy": {
      "allowLoggedOutLiveView": false,
      "allowLoggedOutLiveWrite": false,
      "allowPrivateSessions": false,
      "enforceSingleSession": true,
      "sharedCommunityId": "vh7fr0p46a4nb14mf9anpjpg0183nrg6",
      "sharedSessionScope": "community"
    },
    "leadCapture": {
      "copy": {
        "badge": "Built by a Social Builder on A1Zap",
        "continueCta": "Continue on web",
        "primaryCta": "Start Sign Up",
        "signInCta": "I already have an account",
        "subtitle": "Save your data. Campus-locked to Texas A&M",
        "title": "Sign up to log your rent"
      },
      "domainRule": {
        "allowedDomains": [
          "tamu.edu"
        ],
        "message": "Use your TAMU email to continue",
        "mode": "allowlist"
      },
      "enabled": true,
      "requiredFields": [
        {
          "key": "email",
          "label": "School email",
          "placeholder": "you@tamu.edu",
          "required": true,
          "type": "email"
        }
      ],
      "trigger": "on_load"
    },
    "exportedAt": "2026-09-08T17:39:35.722Z"
  }
]
